import { Box } from "@mui/material";

// Flat white surface — the building block of the RABS Workspace (blue · light)
// redesign. It replaces the heavy frosted GlassCard: NO backdrop-filter and NO
// ambient blur, so pages stay fast. A plain white panel on the light canvas
// with a hairline border and a soft, low shadow.
//
// Props:
//   hover   — soft lift + border highlight on hover (for clickable cards)
//   accent  — hex colour (or gradient string) for the thin top accent bar
//   sx      — extra MUI styles, merged last so callers can override
function FlatCard({ hover = false, accent, sx, children, ...rest }) {
  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        background: "#ffffff",
        border: "1px solid #EEF1F6",
        borderRadius: "16px",
        boxShadow: "0 1px 3px rgba(16, 24, 40, 0.05)",
        transition:
          "transform 0.2s cubic-bezier(0.16,1,0.3,1), box-shadow 0.2s ease, border-color 0.2s ease",
        ...(accent && {
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "3px",
            background:
              typeof accent === "string" && accent.includes("gradient")
                ? accent
                : `linear-gradient(90deg, ${accent}, ${accent}00)`,
          },
        }),
        ...(hover && {
          cursor: "pointer",
          outline: "none",
          "&:hover": {
            transform: "translateY(-3px)",
            boxShadow: "0 8px 24px rgba(16, 24, 40, 0.10)",
            borderColor: "#DBE3EF",
          },
          "&:focus-visible": {
            borderColor: "#3B82F6",
            boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.18)",
          },
        }),
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}

export default FlatCard;
